import React from "react"

export const menu = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M1 8H15M1 3H15M1 13H15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
